module.exports = __webpack_public_path__ + "img/team-uscpaloma.74583876.jpg";